import { HolderOutlined } from '@ant-design/icons';
import { useDraggable } from '@dnd-kit/core';
import { Flex, Typography } from 'antd';
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { Avatar } from '@app/components/Avatar';
import { LEAD_CARD_PATH, PREFIX } from '@app/constants';
import type { ViewSalesFunnelChatComponentProps } from '@app/pages/SalesFunnels/types';
import { SocialIntegrationIcon } from '@app/shared/ui/SocialIntegrationIcon';

import '@pages/SalesFunnels/ViewSalesFunnel/styles/ViewSalesFunnelChatComponent.desktop.scss';

const { Text } = Typography;

export const ViewSalesFunnelChatComponent: React.FC<
  ViewSalesFunnelChatComponentProps
> = ({ lead, stageId, isStagesLeadsComponent = false }) => {
  const { ClientName, ClientPhoto, LastMessage, SocialIntegrationType, Id } =
    lead;

  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: lead.Id,
      data: { stageId },
    });

  const style = isStagesLeadsComponent
    ? {
        transform: transform
          ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
          : undefined,
        opacity: isDragging ? 0.5 : 1,
      }
    : undefined;

  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const goBackRoute = `${pathname}${search}`;

  const navigateToLead = () => {
    if (isStagesLeadsComponent) {
      navigate(`${LEAD_CARD_PATH}?leadId=${Id}`, {
        state: { goBackRoute },
      });
    }
  };

  return (
    <Link
      to={`${LEAD_CARD_PATH}?leadId=${Id}`}
      state={{ goBackRoute }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={`${PREFIX}view-sales-funnel-chat-component`}
        style={style}
        ref={setNodeRef}
        onClick={navigateToLead}
      >
        <div className="avatar">
          <Avatar
            src={ClientPhoto}
            nameFirst={ClientName}
            className="client-avatar"
            size={40}
          />
        </div>
        <div className="chat-content-container">
          <div className="header">
            <Text className="short-text" strong>
              {ClientName || ''}
            </Text>
          </div>
          <div className="message">
            <Flex className="integration-and-message" align="center" gap={8}>
              <SocialIntegrationIcon type={SocialIntegrationType} size="sm" />
              <Text className="short-text">{LastMessage || ''}</Text>
            </Flex>
          </div>
        </div>
        {isStagesLeadsComponent && (
          <div
            className="drag-handle"
            {...listeners}
            {...attributes}
            onClick={(e) => e.stopPropagation()}
          >
            <HolderOutlined />
          </div>
        )}
      </div>
    </Link>
  );
};
